import classnames from 'classnames';
import useEscapeButton from 'hooks/useEscapeButton';
import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';

const CSS = require('./Overlay.module.scss');

interface OverlayProps {
  portalId: string;
  onEsc: () => void;
  className?: any;
  onClick?: (event?: any) => void;
  children: ReactNode;
  fullscreen?: 'all' | 'mobile';
  containerSize?: 'extraSmall' | 'small' | 'inbetween' | 'medium' | 'large';
  noPadding?: boolean;
}

function Overlay({
  onClick,
  children,
  onEsc,
  fullscreen,
  containerSize = 'large',
  noPadding,
}: OverlayProps) {
  useEscapeButton(onEsc);

  const classes = classnames(CSS.Overlay, {
    [CSS.ExtraSmallContainerOverlay]: containerSize === 'extraSmall',
    [CSS.SmallContainerOverlay]: containerSize === 'small',
    [CSS.MediumContainerOverlay]: containerSize === 'medium',
    [CSS.InbetweenContainerOverlay]: containerSize === 'inbetween',
    [CSS.OverlayFullscreen]: fullscreen === 'all',
    [CSS.OverlayFullscreenMobile]: fullscreen === 'mobile',
    [CSS.OverlayNoPadding]: noPadding,
  });

  return (
    <>
      {ReactDOM.createPortal(
        <div onClick={onClick} className={classes}>
          {children}
        </div>,
        document.getElementById('overlay-container') || document.body,
      )}
    </>
  );
}

export default Overlay;
